/**
 * "What's new": games released after launch carry an `added` date in catalog.ts. They get a NEW badge and
 * a place in the homepage's New Games row for NEW_DAYS days.
 */
import { CATALOG, type CatalogEntry } from './catalog';

export const NEW_DAYS = 14;
/** Shown on the homepage. Keep it true: add at least one new game a week. */
export const RELEASE_SCHEDULE = 'New games every week!';

/** Day the site was built (falls back to today in tests and scripts, where Vite's define isn't applied). */
export const LAST_UPDATED: string = typeof __BUILD_DATE__ !== 'undefined' ? __BUILD_DATE__ : new Date().toISOString().slice(0, 10);

const dayMs = (d: string) => Date.parse(`${d}T12:00:00Z`);

export const isNew = (g: Pick<CatalogEntry, 'added'>, now = Date.now()): boolean => !!g.added && now - dayMs(g.added) < NEW_DAYS * 86400e3 && now >= dayMs(g.added) - 86400e3;

/** Games still inside their NEW window, newest first. */
export const newGames = (now = Date.now()): CatalogEntry[] =>
  CATALOG.filter((g) => isNew(g, now)).sort((a, b) => (b.added ?? '').localeCompare(a.added ?? ''));

/** "October 13, 2026" */
export const formatDay = (d: string): string => new Date(`${d}T12:00:00Z`).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC' });

/** The day playsuperfun.com opened; every game without an `added` date was released then. */
export const SITE_LAUNCH = '2026-10-04';
/** Year a game came out on the site, shown on its tile. */
export const releaseYear = (g: Pick<CatalogEntry, 'added'>): string => (g.added ?? SITE_LAUNCH).slice(0, 4);
